import { useStationeryProductsQuery } from './DesignsGallery.graphql.generated';
import type { StationeryProduct } from '@shared/utils/print-price/types';

const ZERO_PRODUCTS: StationeryProduct[] = []; // For stability

export const useProducts = (): StationeryProduct[] => {
  const { data: productData, error: productsError } = useStationeryProductsQuery({
    batchMode: 'fast',
    fetchPolicy: 'cache-first',
    ssr: false,
  });

  if (productsError) throw productsError;

  return productData?.stationeryProducts ?? ZERO_PRODUCTS;
};
